import { Inject } from '@odinjs/odin';
import Controller, { OnUnmount } from '@philips-internal/oswald-ui-core/lib/client';

import BaseController from '../../BaseController';
import { PainScaleAPI } from '@philips-emr/health-professional-components/src/components';
import { AnalogicFacesPainScaleAliases, FragmentNames } from '../../../codegen';

interface ContextDataProps {
  data: {
    setPainScaleValue: (value: number) => void;
  }
}

@Controller({ fragment: FragmentNames.ANALOGIC_FACES_PAIN_SCALE })
class AnalogicFacesController extends BaseController {

  @Inject(AnalogicFacesPainScaleAliases.PAIN_SCALE_ANALOGIC_FACES)
    painScaleApi!: PainScaleAPI;

  @OnUnmount(AnalogicFacesPainScaleAliases.PAIN_SCALE_ANALOGIC_FACES)
  onLayoutUnmount(): void {
    if(this.painScaleApi.getValue()) {
      const { data:  { setPainScaleValue }} = this.context as unknown as ContextDataProps;
      setPainScaleValue(Number(this.painScaleApi.getValue()));
    }
  }
}
export default AnalogicFacesController;
